/**
 * Enum representing the entity types used across the application
 * for custom fields, groups, and related APIs.
 */
export enum EntityType {
  WorkPackage = 'WorkPackage',
  WorkOrder = 'WorkOrder',
  Action = 'Action',
  /** Rules can target a project; the custom-field screens do not use this. */
  Project = 'Project',
}
